var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar"}},[(!_vm.show)?_c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":"","border":false},on:{"click-left":_vm.onClickLeft}})],1):_c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title,"border":false},on:{"click-left":_vm.onClickLeft}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-502122d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/component/NavBar.vue
// module id = null
// module chunks = 